import styled from 'styled-components';

interface IStatusEvolution {
  color: string;
  marginLeft?: boolean;
}

export const StatusEvolutionContainer = styled.div<IStatusEvolution>`
  display: flex;
  background: ${(props) => props.color};
  font-weight: 600;
  color: #fff;
  padding: 2px;
  margin-left: ${(props) => (props.marginLeft ? '4px' : '0')};
  border-radius: 6px;
  justify-content: center;
`;
